import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { SidebarData } from "../../data/json/sidebarData";
import ImageWithBasePath from "../imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import { setExpandMenu, setMobileSidebar } from "../../data/redux/commonSlice";
import Calling from "../../../feature-module/crm/calling";
import { clearContactsCache } from "../../../core/data/redux/slices/LeadSlice";
import { selectWabaTotalUnread, selectWabaChatUnread, selectWabaHistoryUnread } from "../../data/redux/slices/WabaChatSlice";

// Routes always accessible even when locked
const ALLOWED_WHEN_LOCKED = [
  "/crm/upgradePlan",
  "/crm/billing",
  "/crm/settings/profile",
  "/crm/setting/security",
  "/crm/help-and-support",
  "/crm/help-and-support/myTickets",
];

const Sidebar = () => {
  const Location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const miniSidebar = useSelector((state) => state.common.miniSidebar);
  const { role, planStatus, trialEndsAt, accessPausedByAdmin } = useSelector((state) => state.profile);
  const wabaTotalUnread = useSelector(selectWabaTotalUnread);
  const wabaChatUnread = useSelector(selectWabaChatUnread);
  const wabaHistoryUnread = useSelector(selectWabaHistoryUnread);

  const trialExpired = planStatus === "trial" && trialEndsAt && new Date(trialEndsAt) < new Date();
  const planExpired = planStatus === "expired" || planStatus === "cancelled";
  const isLocked = role === "companyAdmin" && (trialExpired || planExpired || accessPausedByAdmin === true);

  const lockReason = accessPausedByAdmin
    ? "Your account has been paused by the administrator."
    : trialExpired
    ? "Your free trial has ended."
    : "Your plan has expired.";

  const handleLockedClick = (e, link) => {
    if (isLocked && !ALLOWED_WHEN_LOCKED.includes(link)) {
      e.preventDefault();
      navigate("/crm/upgradePlan");
    }
  };

  // Returns true if a top-level item should be fully greyed (all its routes are locked)
  const isTopItemLocked = (title) => {
    if (!isLocked) return false;
    if (!title.submenu) return title.link && !ALLOWED_WHEN_LOCKED.includes(title.link);
    // submenu item: locked only if NONE of its subitems are allowed
    const allLinks = (title.submenuItems || []).flatMap((sub) =>
      sub.submenuItems ? sub.submenuItems.map((s) => s.link) : [sub.link]
    );
    return allLinks.length > 0 && allLinks.every((l) => !ALLOWED_WHEN_LOCKED.includes(l));
  };

  // Returns true if a specific submenu leaf link is locked
  const isSubLinkLocked = (link) => isLocked && !!link && !ALLOWED_WHEN_LOCKED.includes(link);
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  const [showDialer, setShowDialer] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(true);
  const [isHovered, setIsHovered] = useState(null);

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const toggleSidebar = (title) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const toggle = () => {
    dispatch(setExpandMenu(true));
  };
  const toggle2 = () => {
    dispatch(setExpandMenu(false));
  };

  useEffect(() => {
    setSubopen(localStorage.getItem("menuOpened"));
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);
  const handleMouseEnter = (menuLabel) => {
    setIsHovered(menuLabel);
  };

  const handleMouseLeave = () => {
    setIsHovered(null);
  };

  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        style={{
          zIndex: "999",
        }}
        // onMouseEnter={toggle}
        // onMouseLeave={toggle2}
      >
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          style={{ height: "100%" }}
        >
          <div
            className="sidebar-inner slimscroll d-flex justify-content-md-between  flex-column"
            style={{ height: "100%", justifyContent: "space-between" }}
          >
            <div id="sidebar-menu" className="sidebar-menu">
              {isLocked && (
                <div style={{
                  background: "#fef3c7",
                  border: "1px solid #f59e0b",
                  borderRadius: 8,
                  padding: "10px 12px",
                  margin: "12px 10px",
                  fontSize: 12,
                  color: "#92400e",
                }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    🔒 Access Restricted
                  </div>
                  <div style={{ marginBottom: 8 }}>{lockReason}</div>
                  <Link
                    to="/crm/upgradePlan"
                    style={{
                      display: "inline-block",
                      background: "#f59e0b",
                      color: "#fff",
                      borderRadius: 4,
                      padding: "3px 10px",
                      fontSize: 11,
                      fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    Upgrade Now →
                  </Link>
                </div>
              )}
              {/* <ul>
              <li className="clinicdropdown theme">
                <Link to="/profile">
                  <ImageWithBasePath
                    src="assets/img/profiles/avatar-14.jpg"
                    className="img-fluid"
                    alt="Profile"
                  />
                  <div className="user-names">
                    <h5>Adrian Davies</h5>
                    <h6>Tech Lead</h6>
                  </div>
                </Link>
              </li>
            </ul> */}

              <ul>
                {SidebarData?.map((mainLabel, index) => (
                  <li className="clinicdropdown" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        if ("submenuItems" in title) {
                          title.submenuItems?.forEach((link) => {
                            link_array.push(link?.link);
                            if (link?.submenu && "submenuItems" in link) {
                              link.submenuItems?.forEach((item) => {
                                link_array.push(item?.link);
                              });
                            }
                          });
                        }
                        title.links = link_array;

                        return (
                          <li className="submenu" key={title.label}>
                            <div
                              onMouseEnter={() => {
                                if (miniSidebar) handleMouseEnter(title.label);
                              }}
                              onMouseLeave={() => {
                                if (miniSidebar) handleMouseLeave();
                              }}
                            >
                              <Link
                                to={title?.submenu ? "#" : title?.link}
                                onClick={(e) => {
                                  handleLockedClick(e, title?.link || "");
                                  if (!title?.submenuItems?.length)
                                    dispatch(setMobileSidebar(false));
                                  toggleSidebar(title?.label);
                                }}
                                style={isTopItemLocked(title) ? { opacity: 0.45, pointerEvents: "auto" } : {}}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                } 
                                ${
                                  title?.submenuItems
                                    ?.map((link) => link?.link)
                                    .includes(Location.pathname) ||
                                  title?.link === Location.pathname
                                    ? "active"
                                    : "" ||
                                      title?.subLink1 === Location.pathname
                                    ? "active"
                                    : "" ||
                                      title?.subLink2 === Location.pathname
                                    ? "active"
                                    : "" ||
                                      title?.subLink3 === Location.pathname
                                    ? "active"
                                    : "" ||
                                      title?.subLink4 === Location.pathname
                                    ? "active"
                                    : ""
                                }
                               `}
                              >
                                <i className={title.icon}></i>
                                <span>{title?.label}</span>
                                {title?.label === "Whatsapp" && wabaTotalUnread > 0 && (
                                  <span style={{ background: "#25d366", color: "#fff", borderRadius: 10, fontSize: 10, fontWeight: 700, padding: "1px 6px", lineHeight: "16px", flexShrink: 0 }}>
                                    {wabaTotalUnread > 99 ? "99+" : wabaTotalUnread}
                                  </span>
                                )}
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map((item) => (
                                  <li
                                    className="submenu submenu-two"
                                    key={item.label}
                                  >
                                    <Link
                                      to={item?.link || "#"}
                                      className={`${
                                        item?.submenuItems
                                          ?.map((link) => link?.link)
                                          .includes(Location.pathname) ||
                                        item?.link === Location.pathname
                                          ? "active subdrop"
                                          : ""
                                      } `}
                                      style={isSubLinkLocked(item?.link) ? { opacity: 0.45, pointerEvents: "auto" } : {}}
                                      onClick={(e) => {
                                        if (isSubLinkLocked(item?.link)) {
                                          e.preventDefault();
                                          navigate("/crm/upgradePlan");
                                          return;
                                        }
                                        dispatch(setMobileSidebar(false));
                                        toggleSubsidebar(item?.label);
                                      }}
                                    >
                                      {item?.label}
                                      {item?.label === "Chat" && wabaChatUnread > 0 && (
                                        <span style={{ background: "#25d366", color: "#fff", borderRadius: 10, fontSize: 10, fontWeight: 700, padding: "1px 6px", lineHeight: "16px", flexShrink: 0 }}>
                                          {wabaChatUnread > 99 ? "99+" : wabaChatUnread}
                                        </span>
                                      )}
                                      {item?.label === "History" && wabaHistoryUnread > 0 && (
                                        <span style={{ background: "#6366f1", color: "#fff", borderRadius: 10, fontSize: 10, fontWeight: 700, padding: "1px 6px", lineHeight: "16px", flexShrink: 0 }}>
                                          {wabaHistoryUnread > 99 ? "99+" : wabaHistoryUnread}
                                        </span>
                                      )}
                                      <span
                                        className={
                                          item?.submenu ? "menu-arrow" : ""
                                        }
                                      />
                                    </Link>
                                    <ul
                                      style={{
                                        display:
                                          subsidebar === item?.label
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {item?.submenuItems?.map((items) => (
                                        <li key={items.label}>
                                          <Link
                                            to={items?.link}
                                            className={`${
                                              subsidebar === items?.label
                                                ? "submenu-two subdrop"
                                                : "submenu-two"
                                            } ${
                                              items?.submenuItems
                                                ?.map((link) => link.link)
                                                .includes(Location.pathname) ||
                                              items?.link === Location.pathname
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            {items?.label}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                              {isHovered === title.label && (
                                <>
                                  <div
                                    style={{
                                      background: "transparent",
                                      position: "absolute",
                                      width: "100px",
                                      height: "100%",
                                      top: 0,
                                      left: 0,
                                      // zIndex: 1,
                                    }}
                                    onMouseEnter={() =>
                                      handleMouseEnter(title.label)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                  ></div>
                                  <div
                                    className="showOnHover"
                                    onMouseEnter={() =>
                                      handleMouseEnter(title.label)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                  >
                                    {isHovered === title.label && (
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          background: "#12344d",
                                          // paddingLeft: 8,
                                          // paddingRight: 8,
                                          borderRadius: 6,
                                          minWidth: 240,
                                          position: "absolute",
                                          textAlign: "center",
                                          top: 0,
                                          left: 0,
                                          // zIndex: 1,
                                        }}
                                        onMouseEnter={() =>
                                          handleMouseEnter(title.label)
                                        }
                                        onMouseLeave={handleMouseLeave}
                                      >
                                        {" "}
                                        <div className="sideMenuHeadingContainer">
                                          <p className="sideMenuHeading">
                                            {title.label}
                                          </p>
                                        </div>
                                        <ul
                                          style={{
                                            marginBottom: 0,
                                            paddingLeft: 8,
                                            paddingRight: 8,
                                            paddingBottom: 12,
                                            display: "block",
                                          }}
                                        >
                                          {title?.submenuItems?.map((item) => (
                                            <li
                                              className="submenu submenu-two hoverMenu subMenuLi"
                                              key={item.label}
                                            >
                                              {/* {console.log(title.submenuItems, "title.submenuItems")} */}
                                              <Link
                                                to={item?.link}
                                                className={`${
                                                  item?.submenuItems
                                                    ?.map((link) => link?.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  item?.link ===
                                                    Location.pathname
                                                    ? "active subdrop"
                                                    : ""
                                                } `}
                                                onClick={() => {
                                                  toggleSubsidebar(item?.label);
                                                }}
                                              >
                                                <div className="me-2">
                                                  {item?.icon}
                                                </div>
                                                {item?.label}
                                                <span
                                                  className={
                                                    item?.submenu
                                                      ? "menu-arrow"
                                                      : ""
                                                  }
                                                />
                                              </Link>
                                              <ul style={{}}>
                                                {item?.submenuItems?.map(
                                                  (items) => (
                                                    <li key={items.label}>
                                                      <Link
                                                        to={items?.link}
                                                        className={`${
                                                          subsidebar ===
                                                          items?.label
                                                            ? "submenu-two subdrop"
                                                            : "submenu-two"
                                                        } ${
                                                          items?.submenuItems
                                                            ?.map(
                                                              (link) =>
                                                                link.link
                                                            )
                                                            .includes(
                                                              Location.pathname
                                                            ) ||
                                                          items?.link ===
                                                            Location.pathname
                                                            ? "active"
                                                            : ""
                                                        }`}
                                                      >
                                                        {items?.label}
                                                      </Link>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-4" style={{ padding: 15 }}>
              <Link
                to=""
                className={`d-flex align-items-center suserset me-2 ps-2`}
                data-bs-toggle="modal"
                data-bs-target="#logoutModal"
              >
                <ImageWithBasePath
                  src="assets/img/icons/logout.png"
                  alt="Logout"
                  width={15}
                  className="me-3"
                />
                <span>Logout</span>
              </Link>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
